module.exports = __webpack_public_path__ + "site/img/54.334fd831.jpg";